import { render, staticRenderFns } from "./commissioniPolizzeCommerciali.vue?vue&type=template&id=6f9e20c6&"
import script from "./commissioniPolizzeCommerciali.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniPolizzeCommerciali.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports